import { useState } from "react";
import { UploadPanel } from "./components/UploadPanel";
import { UploadResult } from "./components/UploadResult";
import { RecordsView } from "./components/RecordsView";
import { StatsView } from "./components/StatsView";
import "./styles.css";

type TabKey = "upload" | "records" | "stats";

function App() {
  const [tab, setTab] = useState<TabKey>("upload");

  return (
    <main className="app-shell">
      <section className="hero">
        <h1>出发四班点赞&截图上传管理系统</h1>
        <nav className="tabs">
          <button
            className={tab === "upload" ? "active" : ""}
            type="button"
            onClick={() => setTab("upload")}
          >
            上传
          </button>
          <button
            className={tab === "records" ? "active" : ""}
            type="button"
            onClick={() => setTab("records")}
          >
            查看记录
          </button>
          <button
            className={tab === "stats" ? "active" : ""}
            type="button"
            onClick={() => setTab("stats")}
          >
            上传统计
          </button>
        </nav>
      </section>

      {tab === "upload" && (
        <>
          <UploadPanel />
          <UploadResult />
        </>
      )}
      {tab === "records" && <RecordsView />}
      {tab === "stats" && <StatsView />}
    </main>
  );
}

export default App;

